import Icon from '../../components/Icon.vue'

Icon.register({
  'brands/google-play': {
    width: 512,
    height: 512,
    paths: [
      {
        d: 'M325.3 234.3l-220.7-221.3 280.8 161.2zM47 0l256.6 255.9-256.6 256c-13-6.8-21.7-19.2-21.7-35.3v-441.3c0-16.1 8.7-28.5 21.7-35.3zM472.2 225.6c19.2 14.3 19.2 46.5 1.2 60.8l-60.1 34.1-65.7-64.5 65.7-64.5zM104.6 499l220.7-221.3 60.1 60.1z'
      }
    ]
  }
})
